/* nl-ad-params — forwards the page's query string (gclid, fbclid, utm_*) onto
   marked CTA links so ad attribution survives the hop to the product page.

   Hooks:     <a data-nl-ad-params href="…">                    one link
              <div data-nl-ad-params-scope> … </div>            every link inside whose href
                                                                contains /products/ (rich text
                                                                links cannot carry attributes)
   Optional:  data-nl-utm-content="lx01_testa" on the link or on an enclosing element — set as
              utm_content only when neither the page URL nor the link already carries one.
   Behaviour: merges on load, on section load, and again on click/focus (so a link whose href
              another script rewrites stays correct). Never overwrites a param the link
              already has. No-op without a query string and without data-nl-utm-content.
   Public:    window.nlAdParams.apply(linkElement) */
(function () {
  if (window.nlAdParams) return;

  var SELECTOR = 'a[data-nl-ad-params], [data-nl-ad-params-scope] a[href*="/products/"]';

  function apply(a) {
    if (!a || !a.getAttribute) return;
    var raw = a.getAttribute('href');
    if (!raw || raw.charAt(0) === '#') return;
    var url;
    try { url = new URL(raw, location.href); } catch (e) { return; }
    var changed = false;
    var page = new URLSearchParams(location.search);
    page.forEach(function (v, k) {
      if (!url.searchParams.has(k)) { url.searchParams.set(k, v); changed = true; }
    });
    var holder = a.closest ? a.closest('[data-nl-utm-content]') : null;
    var content = holder ? holder.getAttribute('data-nl-utm-content') : null;
    if (content && !url.searchParams.has('utm_content')) {
      url.searchParams.set('utm_content', content);
      changed = true;
    }
    if (!changed) return;
    a.setAttribute('href', url.origin === location.origin ? url.pathname + url.search + url.hash : url.href);
  }

  function applyAll(root) {
    [].forEach.call((root || document).querySelectorAll(SELECTOR), apply);
  }

  function onPointer(e) {
    var a = e.target && e.target.closest ? e.target.closest(SELECTOR) : null;
    if (a) apply(a);
  }

  document.addEventListener('click', onPointer, true);
  document.addEventListener('focusin', onPointer);
  document.addEventListener('shopify:section:load', function (e) { applyAll(e.target); });
  /* Delegated document-level listeners only: nothing per-section to tear down. */
  document.addEventListener('shopify:section:unload', function () {});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { applyAll(); });
  else applyAll();

  window.nlAdParams = { apply: apply };
})();
